import React from 'react';

import * as styles from './styles/styles.module.scss';

import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const Difficulty = ({ difficulty }) => {
  difficulty = parseInt(difficulty);
  if (!difficulty) return <span className={`${styles.diff} ${styles.missing}`}>{StringConstantsMixin.strings.DIFFICULTY.LOWER.DEFAULT}</span>;
  if (difficulty < 2)
    return <span className={`${styles.diff} ${styles.easy} ${styles.selected}`}>{StringConstantsMixin.strings.DIFFICULTY.LOWER.EASY}</span>;
  if (difficulty < 4)
    return <span className={`${styles.diff} ${styles.moderate} ${styles.selected}`}>{StringConstantsMixin.strings.DIFFICULTY.LOWER.MODERATE}</span>;
  return <span className={`${styles.diff} ${styles.hard} ${styles.selected}`}>{StringConstantsMixin.strings.DIFFICULTY.LOWER.HARD}</span>;
};

export default Difficulty;